import React from 'react';
import { Dialog, DialogContent, DialogTitle, Stack, Typography } from '@mui/material';
import { IAdminAuditUser } from '../Interfaces/IAdminAudit';

interface AuditInfoDialogProps {
    open: boolean;
    onClose: () => void;
    title: string;
    createdBy?: IAdminAuditUser | null;
    createdAt?: string | null;
    updatedBy?: IAdminAuditUser | null;
    updatedAt?: string | null;
    deletedBy?: IAdminAuditUser | null;
    deletedAt?: string | null;
}

const formatDateTime = (value?: string | null): string => {
    if (!value) {
        return '-';
    }
    return new Intl.DateTimeFormat('de-DE', {
        dateStyle: 'medium',
        timeStyle: 'short',
    }).format(new Date(value));
};

const AuditInfoDialog: React.FC<AuditInfoDialogProps> = ({
    open,
    onClose,
    title,
    createdBy,
    createdAt,
    updatedBy,
    updatedAt,
    deletedBy,
    deletedAt,
}) => (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
        <DialogTitle>{title}</DialogTitle>
        <DialogContent>
            <Stack spacing={1.5}>
                <Typography variant="body2">Erstellt von: {createdBy?.displayName ?? '-'}</Typography>
                <Typography variant="body2">Erstellt am: {formatDateTime(createdAt)}</Typography>
                <Typography variant="body2">Zuletzt bearbeitet von: {updatedBy?.displayName ?? createdBy?.displayName ?? '-'}</Typography>
                <Typography variant="body2">Zuletzt bearbeitet am: {formatDateTime(updatedAt ?? createdAt)}</Typography>
                <Typography variant="body2">Gelöscht von: {deletedBy?.displayName ?? '-'}</Typography>
                <Typography variant="body2">Gelöscht am: {formatDateTime(deletedAt)}</Typography>
            </Stack>
        </DialogContent>
    </Dialog>
);

export default AuditInfoDialog;
